import React from 'react';
import { IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

/** Tamaño de página estándar de todas las secciones paginadas del panel. */
export const PANEL_PAGE_SIZE = 10;

interface PaginationProps {
    total: number;
    limit: number;
    offset: number;
    /** Se invoca con el nuevo offset (nunca fuera de rango). */
    onChange: (offset: number) => void;
    disabled?: boolean;
    /** Etiqueta para accesibilidad (distingue los controles entre secciones). */
    label?: string;
}

/**
 * Control de paginación reutilizable (backend LIMIT/OFFSET): "Página X de Y"
 * + anterior/siguiente. Los botones se deshabilitan en los bordes.
 */
const Pagination: React.FC<PaginationProps> = ({
    total,
    limit,
    offset,
    onChange,
    disabled = false,
    label = '',
}) => {
    const page = Math.floor(offset / limit) + 1;
    const totalPages = Math.max(1, Math.ceil(total / limit));
    const canPrev = offset > 0;
    const canNext = offset + limit < total;
    const suffix = label ? ` ${label}` : '';

    return (
        <span
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: 4,
                fontWeight: 400,
                fontSize: 13,
                color: '#6B7280',
            }}
        >
            Página {page} de {totalPages}
            <IconButton
                size='small'
                aria-label={`Página anterior${suffix}`}
                disabled={disabled || !canPrev}
                onClick={() => onChange(Math.max(0, offset - limit))}
            >
                <ChevronLeftIcon fontSize='small' />
            </IconButton>
            <IconButton
                size='small'
                aria-label={`Página siguiente${suffix}`}
                disabled={disabled || !canNext}
                onClick={() => onChange(offset + limit)}
            >
                <ChevronRightIcon fontSize='small' />
            </IconButton>
        </span>
    );
};

export default Pagination;
